import { MenuItem } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import { DeliveryMethod } from "../types/queries";
import InvoiceInfoAdditionalFields from "./InvoiceInfoAdditionalFields";
import FormGridRow from "../../../common/components/functional/formGridRow/FormGridRow";

const InvoiceInfo = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const invoiceDeliveryMethodOptions = Object.values(DeliveryMethod).map(
    (deliveryMethod) => deliveryMethod,
  );

  return (
    <FormSection title={t("customers:companyInfo:invoiceDeliveryInfo")} margin>
      <FormGridRow
        label={t("customers:companyInfo:invoiceDeliveryMethod")}
        labelSize={2.8}
        fieldSize={9.2}
      >
        <Controller
          name="invoiceSettings.deliveryMethod"
          control={control}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "203px" }}
              fullWidth
              size="small"
              value={field.value}
              select
            >
              {invoiceDeliveryMethodOptions.map((deliveryMethod) => (
                <MenuItem key={deliveryMethod} value={deliveryMethod}>
                  {t(`customers:companyInfo:${deliveryMethod}`)}
                </MenuItem>
              ))}
            </CommonTextField>
          )}
        />
      </FormGridRow>
      <InvoiceInfoAdditionalFields />
    </FormSection>
  );
};

export default InvoiceInfo;
